import React from 'react';

import styled from 'styled-components';
import { InstructionHeader, SubTitle1 } from '../Text';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.8em 1em;
  width: 100%;
`;

const TitleContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`;

const SubTitleContainer = styled.div`
  padding: 0 5em;
  @media (max-width: 480px) {
    padding: 0em;
  }
`;

interface Props {
  headerText: string | undefined;
  subHeader?: string;
}

export function InstallationInstructionsHeader({
  headerText,
  subHeader,
}: Props) {
  return (
    <Container>
      <TitleContainer>
        <InstructionHeader>{headerText}</InstructionHeader>
        {!!subHeader && (
          <SubTitleContainer>
            <SubTitle1 marginTop={'10px'} color={'rgba(0, 0, 0, 0.6)'}>
              {subHeader}
            </SubTitle1>
          </SubTitleContainer>
        )}
      </TitleContainer>
    </Container>
  );
}
